// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"SendNotePage_checkbox__6jbJO","navButtons":"SendNotePage_navButtons__tY2uf","previousMessagesContainer":"SendNotePage_previousMessagesContainer__SeMFR"};